export interface ScriptAttributes {
  [key: string]: { value?: string }
}

export default function getKlarnaScriptAttributes() {
  const selector = 'script[src*="klarna.js"]'
  const script = document.querySelector(selector)
  return script?.attributes
}
